var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBevoFuelComp48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M22.1,26.9c0-0.7-1.5-3.3-1.7-3.3l-0.8,1.3c-0.6,1-0.8,1.6-0.8,2c0,1,0.7,1.7,1.7,1.7 C21.4,28.6,22.1,27.9,22.1,26.9z M24.1,20.4v-5.5h-7.4v5.5H24.1z M32.2,32.5c-2,0-3.5-1.7-3.5-4.1c0-0.8,0.3-1.9,0.6-2.8 c0.3-0.9,0.5-1.8,0.5-2.4c0-1.4-0.8-2.1-2.3-2.1l-0.5,0v12.8h1.3V36H12.4v-2.1h1.3V12H27v7.4c3.4,0,4.5,1.5,4.5,3.9 c0,0.5-0.2,1.3-0.6,2.5c-0.4,1.3-0.6,2.1-0.6,2.7c0,1.4,0.8,2.4,1.6,2.4c1.1,0,1.8-1.5,1.8-3.8V20l-1.3-1.3v-2.8l-2.3-2.5l1.4-1.3 l3.8,4.2v10.8c0,2.2-0.4,3.6-1.2,4.3C33.7,32.2,32.9,32.5,32.2,32.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBevoFuelComp48);
export default __webpack_public_path__ + "static/media/ic_bevo_fuel-comp_48.1ce8f9b31363943382e1c7988c272e8a.svg";
export { ForwardRef as ReactComponent };